import tw, { css, styled } from 'twin.macro';
import { type InfoTagSize, type InfoTagColor } from '@/components/InfoTag/InfoTag';

const tagColorMap: Record<InfoTagColor, ReturnType<typeof css>> = {
  color1: css`
    ${tw`bg-tertiary-t1`}
    ${tw`text-primary-p1`}
  `,
  color2: css`
    ${tw`bg-tertiary-t2`}
    ${tw`text-neutrals-n1`}
  `,
  color3: css`
    ${tw`bg-tertiary-t3`}
    ${tw`text-primary-p1`}
  `,
  color4: css`
    ${tw`bg-ui-colours-ui3`}
    ${tw`text-primary-p1`}
  `,
  color5: css`
    ${tw`bg-secondary-s1`}
    ${tw`text-neutrals-n1`}
  `,
};

export const StyledInfoTag = styled.span<{ tagSize: InfoTagSize; tagColor: InfoTagColor }>`
  ${tw`inline-flex items-center justify-center`}
  ${tw`font-inter font-semi-bold`}
  ${tw`whitespace-nowrap`}
  ${tw`text-tag-s`}
  ${tw`rounded-[40px]`}

  ${({ tagSize }) => (tagSize === 'small' ? tw`px-1 py-[2px]` : tw`px-[14px] py-[7px]`)}
  ${({ tagColor }) => tagColorMap[tagColor]}
`;
